<template>
  <b-modal
    size="lg"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div>
            <span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-row>
        <b-col cols="12">
          <b-form-group>
            <lg-form-select
              v-model="form.frequencia"
              :loadFunction="loadFrequenciaList"
              labelFormGroupBind="Frequência:"
              label="descricao"
              :description="''"
              :filterList="false"
              required
            />
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import { FREQUENCIA_ALERTA_MOVIMENTACAO_OPTIONS } from "@/constants/frequencyOptionsAlertaMovimentacao";

export default {
  components: {
    LgFormSelect,
  },
  name: "FrequenciaEnvioEmailModal",
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        frequencia: null,
      },
      frequenciasOptions: FREQUENCIA_ALERTA_MOVIMENTACAO_OPTIONS,
    };
  },
  methods: {
    async loadFrequenciaList() {
      return {
        data: {
          content: this.frequenciasOptions,
          totalPages: 1,
        },
      };
    },
    async salvar() {

      if (this.form.frequencia === null) {
        this.$bvToast.toast("Preencha todos os campos obrigatórios", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const valorPropriedade = this.form.frequencia.value;

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },

    cancelar() {
      this.$emit("close");
    },

    carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        this.form.frequencia = FREQUENCIA_ALERTA_MOVIMENTACAO_OPTIONS.find(f=> f.value == parseInt(this.configuracao.valorPropriedade, 10))|| null; 

      }
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
